/**
 * App Config File
 */
const AppConfig = {
  appLogo: require("Assets/img/nxt-Coverphoto.png"), // App Logo
  brandName: "Rhenus Logistics", // Brand Name
  navCollapsed: false, // Sidebar collapse
  darkMode: false, // Dark Mode
  boxLayout: false, // Box Layout
  portal: "OPERATIONS",
  rtlLayout: false, // RTL Layout
  miniSidebar: false, // Mini Sidebar
  enableSidebarBackgroundImage: false, // Enable Sidebar Background Image
  sidebarImage: require("Assets/img/sidebar-4.jpg"), // Select sidebar image
  sidebarTenantLogo: "https://www.rhenus.group/fileadmin/user_upload/rhenus-logo.svg",
  isDarkSidenav: true, // Set true to dark sidebar
  enableThemeOptions: false, // Enable Theme Options
  locale: {
    languageId: "english",
    locale: "en-US",
    name: "English",
    icon: "en"
  },
  enableUserTour: true,
  copyRightText1: "Nxt Software Solutions LLC © ", // Copy Right Text
  copyRightText2: " All Rights Reserved", // Copy Right Text
  // light theme colors var(--primary)
  themeColors: {
    primary: "#fa3a12",
    primaryDark: "#6e6e6e",
    portalFontColor: "black",
    secondary: "#fabb00",
    success: "#00D014",
    danger: "#FF3739",
    warning: "#fabb00",
    info: "#85959d",
    dark: "#6e6e6e",
    default: "#FAFAFA",
    greyLighten: "#A5A7B2",
    grey: "#677080",
    white: "#FFFFFF",
    purple: "#896BD6",
    yellow: "#D46B08"
  },
  // dark theme colors
  darkThemeColors: {
    darkBgColor: "#424242"
  }
};
console.log("LOAD APP CONFIG!!!!!");
document
  .querySelector("body")
  .style.setProperty("--primary", AppConfig.themeColors.primary);
document
  .querySelector("body")
  .style.setProperty("--primaryDark", AppConfig.themeColors.primaryDark);
document
  .querySelector("body")
  .style.setProperty(
    "--portalFontColor",
    AppConfig.themeColors.portalFontColor
  );
document
  .querySelector("body")
  .style.setProperty("--secondary", AppConfig.themeColors.secondary);

export default AppConfig;
